// extracted by mini-css-extract-plugin
export default {"about":"style_about__Gqo4n","header":"style_header__Yia2U"};